import styled from "styled-components"

export const BannerModuleStyles = styled.section`
  position: relative;
  //background: #F4F2EE;
  padding: 30px var(--borderSpacing);
  overflow: hidden;
  height: 50vh;
  opacity: 1;

  @media (min-width: 768px) {
    height: 60vh;
  }

  @media (min-width: 1024px) {
    height: 75vh;
  }

  .background {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    overflow: hidden;
    background: #EDFF00;
    background: radial-gradient(circle at center, rgba(242, 255, 112, 0.5) 0, var(--brand-yellow) 20%, var(--brand-yellow) 100%);
    animation: 2s opacity-easeInBounce reverse;
  }

  .noise {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    background: url(/noise.png);
    background-position: center center;
    z-index: 1;
    opacity: .5;
  }

  .svgWrappers {
    position: relative;
    height: 100%;
    width: 100%;
  }

  .innerCircle {
    height: 32vw;
    left: 50%;
    position: absolute;
    top: 50%;
    width: 32vw;
    transform: translate3d(-50%, -50%, 0);
    //opacity: 0.75;
    opacity: 0;

    svg {
      fill: #ffffff;
    }

    &.active {
      .innerAnim {
        animation: spin 60s linear infinite reverse;
      }
    }
  }

  .outerCircle {
    height: 110vw;
    left: 50%;
    position: absolute;
    top: 50%;
    width: 110vw;
    transform: translate3d(-50%, -50%, 0);
    //opacity: 0.5;
    display: none;
    @media (min-width: 768px) {
      display: block;
    }
    
    svg {
      //fill: aliceblue;
    }

    &.active {
      .innerAnim {
        animation: spin 45s linear infinite;
      }
    }
  }

  .triangleWrapper {

  }

  .triangle-canvas {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 125%;
    height: 125%;
    transform: translate(-50%, -50%);
  }

  .triangle {
    fill: none;
    stroke: var(--light-colour);
    stroke-width: 15;
    transform-origin: center center;
    animation: triangle-animation 10s linear infinite;
  }

  .triangle-1 {
    animation-delay: 0s;
  }

  .triangle-2 {
    animation-delay: -0.5s;
  }

  .triangle-3 {
    animation-delay: -1s;
  }

  .triangle-4 {
    animation-delay: -1.5s;
  }

  .triangle-5 {
    animation-delay: -2s;
  }

  .triangle-6 {
    animation-delay: -2.5s;
  }

  .triangle-7 {
    animation-delay: -3s;
  }

  .triangle-8 {
    animation-delay: -3.5s;
  }

  .triangle-9 {
    animation-delay: -4s;
  }

  .triangle-10 {
    animation-delay: -4.5s;
  }

  .triangle-11 {
    animation-delay: -5s;
  }

  .triangle-12 {
    animation-delay: -5.5s;
  }

  .triangle-13 {
    animation-delay: -6s;
  }

  .triangle-14 {
    animation-delay: -6.5s;
  }

  .triangle-15 {
    animation-delay: -7s;
  }

  .triangle-16 {
    animation-delay: -7.5s;
  }

  .triangle-17 {
    animation-delay: -8s;
  }

  .triangle-18 {
    animation-delay: -8.5s;
  }

  .triangle-19 {
    animation-delay: -9s;
  }

  .triangle-20 {
    animation-delay: -9.5s;
  }

  @keyframes triangle-animation {
    0% {
      transform: scale(0) rotate(0deg);
      opacity: 1;
    }

    100% {
      transform: scale(3) rotate(45deg);
      opacity: 0;
    }
  }


  @keyframes spin {
    to {
      transform: rotate(1turn)
    }
  }

  &.small {
    //display: none;
    height: 25vh;
    overflow: visible;

    @media (min-width: 768px) {
      height: 30vh;
    }

    @media (min-width: 1024px) {
      height: 40vh;
    }

    .logo__image {
      margin: 3vh auto 0;

      @media (min-width: 768px) {
        margin: 5vh auto 0;
        width: 80vw;
      }

      @media (min-width: 1200px) {
        width: 50vw;
      }
    }
  }

  .container {
    height: 100%;
    max-width: 1200px;
  }

  .banner__image {
    position: absolute;
    //top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;

    &--bakers {
      bottom: -10%;
      @media (min-width: 600px) {
        bottom: -15%;
      }
    }

  }

  .logo__image {
    position: relative;
    display: block;
    margin: 15vh auto 0;
    width: 50%;

    @media (min-width: 768px) {
      margin: 25vh auto 0;
      width: 80vw;
    }

    @media (min-width: 1200px) {
      margin: 5vh auto 0;
      width: 50%;
    }
    //height: 100%;
    z-index: 1;
  }

  .banner__content {
    position: relative;
    z-index: 2;
    min-height: 33vh;
    width: 100%;
    max-width: 700px;
  }

  @keyframes opacity-easeInBounce {
    0% {
      opacity: 1;
    }

    4% {
      opacity: 0.8;
    }

    8% {
      opacity: 0.99;
    }

    18% {
      opacity: 0.4;
    }
    34% {
      opacity: 0.68;
    }

    80% {
      opacity: 0.05;
    }

    88% {
      opacity: 0.0;
    }

    100% {
      opacity: 0;
    }

  }
`
